// 클래스명 결합 유틸. 조건부 클래스를 깔끔히 합치기 위한 최소 구현(외부 의존성 없이).
// falsy 값은 버리고 공백으로 join 한다. 중복 제거까지는 하지 않는다(Tailwind 순서 의존 회피).
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
